// JsFromRoutes CacheKey c72923c11b370c540e57aad87e7ef563
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/template_versions/export'),
  create: definePathHelper('post', '/template_versions/export'),
}
